import { useEffect, useState } from 'react';
import { useLoginContext } from '../../../../../App';
import useGettingWidgetData from '../../../hooks/useGettingWidgetData';
import useB2BTranslation from '../../../../b2b-common/hooks/useB2BTranslation';
import { Box } from '@mui/material';
import ORGANIZATION_SDGS_PIECHART_WidgetLayout from './ORGANIZATION_SDGS_PIECHART_WidgetLayout';

const ORGANIZATION_SDGS_PIECHART_Widget = ({ widget, atPublicDashboard = false, password = null }) => {
    const { loginData } = useLoginContext();
    const { t } = useB2BTranslation('b2b-reporting');
    const { widgetData, loading } = useGettingWidgetData(widget, atPublicDashboard, password);
    const [orgImpact, setOrgImpact] = useState(null);
    useEffect(() => {
        if (!widgetData) return;
        setOrgImpact(widgetData?.widgetResponse?.plansImpact || []);
    }, [widgetData]);
    
    if ( loading || !orgImpact || orgImpact.length === 0) {
        return (
            <Box className={'OrgSDGPieWidget-loading'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <Box className={'OrgSDGPieWidget-loading-text'}>
                    {t('Loading...')}
                </Box>
            </Box>
        );
    }

    const data = orgImpact.map((impactItem, index) => {
        return {
            levelN_ItemId: impactItem.dtoReference.theOne.levelN_ItemId,
            indicatorUUIDs: impactItem.dtoReference.theMany.map(indicator => indicator.indicatorUUID),
        };
    });

    const size = widget?.widgetConfig?.extraFields?.size || 170;

    return (
        <Box className={'OrgSDGPie-container'} height={`${size}px`} width={`${size}px`}
            display={'flex'} justifyContent={'center'} alignItems={'center'}
        >
            <ORGANIZATION_SDGS_PIECHART_WidgetLayout
                data={data}
                size={size}
                locale={widget?.widgetConfig?.extraFields?.locale || loginData.locale || 'es'}
                showLogo={true}
            />
        </Box>
    );

}

export default ORGANIZATION_SDGS_PIECHART_Widget;